import React, { memo } from "react";
import { useTranslation, Trans } from "react-i18next";
import { P1 } from "@talentbait/shared-components";

import DraftCampaignStepLayout from "./DraftCampaignStepLayout";

const DraftCampaignFinalInfoStep = (props) => {
  const { t } = useTranslation();

  return (
    <DraftCampaignStepLayout
      header={t("Great work 🎉")}
      continueText={t("Create your first Campaign draft")}
      {...props}
    >
      <Trans parent={P1}>
        Now that you're familiar with TalentBait you're ready to{" "}
        <b>start creating your first campaign draft.</b>
      </Trans>
      <Trans parent={P1}>
        Don't worry, you don't need to be ready for a Space mission. TalentBait is an easy tool and
        we'll be here to help you in all the steps.
      </Trans>
    </DraftCampaignStepLayout>
  );
};

export default memo(DraftCampaignFinalInfoStep);
